import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';

export default () => (
  <SectionContainer
    id='anti-fraud-efforts-insurance-fraud'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          align='center'>
          Insurance Fraud
        </Typography>
        <Typography component='h3'>
          Our fight against insurance fraud
        </Typography>
        <Typography>
          Insurance fraud takes many forms, from inflating a claim to faking a disability. It occurs when individuals intentionally deceive an insurance company to collect money that isn&#39;t rightfully theirs.
        </Typography>
        <Typography>
          Each year insurance fraud costs all types of insurance companies and their customers billions of dollars. In fact, the Coalition Against Insurance Fraud estimates that insurance fraud costs Americans at least &#36;80 billion a year. Northwestern Mutual is proactive in its effort to fight insurance fraud, and we are continually improving our procedures for prevention, detection and investigation of insurance fraud.
        </Typography>
        <Typography component='h3'>
          Passing on costs, passing on savings
        </Typography>
        <Typography>
          Each incident of fraud forces insurance companies to absorb unnecessary expenses. Those excess expenses can cause companies to raise premium rates. Or, in the case of mutual insurance companies, those expenses may result in lower dividend amounts for policyowners. Conversely, when fraud decreases, the money an insurance company saves can be passed on to its policyowners.
        </Typography>
        <Typography component='h3'>
          What is insurance fraud?
        </Typography>
        <Typography>
          According to The Coalition Against Insurance Fraud &#34;Insurance fraud occurs when people deceive an insurance
          company or agent to obtain policies or collect money to which they are not entitled. Similarly, insurers
          and agents also can defraud customers, or even each other.&#34;
        </Typography>
        <Typography component='h4'>
          Some examples of insurance fraud include:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Intentionally failing to disclose significant medical conditions or other material facts on an insurance application.' },
            { bulletText: 'Collecting disability benefits after returning to work.' },
            { bulletText: 'A representative who bills a client personally without delivering a policy.' },
            { bulletText: 'Unscrupulous health care providers who bill twice for the same service or for services not provided.' },
            { bulletText: 'Attempting to collect life insurance benefits while the insured is alive.' },
            { bulletText: 'A physician who assists a claimant by certifying an unfounded disability claim.' },
            { bulletText: 'Taking an unauthorized loan on a life insurance policy by an individual.' },
          ]} />
        <Typography component='h3'>
          What is being done?
        </Typography>
        <Typography>
          Northwestern Mutual has a Special Investigations Unit (SIU) whose responsibility is to investigate suspected fraud and to help local law enforcement officials prosecute offenders. The SIU works to detect, prevent and resolve fraudulent activities perpetrated against Northwestern Mutual.
        </Typography>
        <Typography>
          Additionally, many states actively prosecute insurance fraud through established fraud bureaus. We urge you to visit your state&#39;s department of insurance Website for information about insurance fraud specific to your state. Also, the following organizations maintain Websites that provide information about the problem of insurance fraud:
        </Typography>
        <BulletedList
          disableBottomPadding
          bulletedListData={[
            { bulletText: 'Association of Certified Fraud Examiners' },
            { bulletText: 'Coalition Against Insurance Fraud' },
            { bulletText: 'National Fraud Information Center' },
            { bulletText: (<>National Healthcare Anti&#45;Fraud Association</>) },
            { bulletText: 'Health Insurance Association of America' },
          ]} />
      </Col>
    </Row>
  </SectionContainer>
);
